import * as types from "../constants/skillConstants";
import axios from "../../axios";
import { getKeycloackToken } from "./auth";
import { notify } from "./snack";
import { read, utils } from "xlsx";
import _ from "lodash";
import {
  sendMessageToExtension,
  desktopAgentExists,
} from "../../utility/extension";
import { getCookie, setCookie } from "../../common/cookie_helper";

export const filterSearchItem = (currentItem) => (dispatch) => {
  dispatch({ type: types.UPDATE_SEARCH_TERM, payload: currentItem });
};

export const publishFlow = (payload) => async (dispatch) => {
  try {
    let token = await getKeycloackToken();
    var config = {
      method: "post",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      url: `${process.env.REACT_APP_BOT_SERVICE_URL}/draftSkills/publish`,
      data: payload,
    };
    const result = await axios(config);
    dispatch(notify("Success", "Flow successfully published!"));
  } catch (err) {
    dispatch(
      notify("error", "Failed to delete Draft Agent: " + err.toString())
    );
  }
};

export const updateSkillVariables = (payload) => async (dispatch) => {
  try {
    let token = await getKeycloackToken();
    var config = {
      method: "put",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      url: `${process.env.REACT_APP_BOT_SERVICE_URL}/draftSkills/variables`,
      data: payload,
    };
    const result = await axios(config);
    dispatch({ type: types.GET_DRAFTS_BY_ID, payload: result.data.data });
    dispatch(notify("Success", "Saved successfully "));
  } catch (err) {
    dispatch(notify("error", "Failed to delete Agent: " + err.toString()));
  }
};

export const automationSearch = (data) => async (dispatch) => {
  let _orgId = getCookie("org_id");
  const orgId = _orgId;
  let token = await getKeycloackToken();

  var newUrl;
  if (data) {
    newUrl = `${process.env.REACT_APP_BOT_SERVICE_URL}/skills/searchAutomation?query=${data.query}&page=${data.page}&pageSize=10`;
  }
  const config = {
    method: "get",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    url: newUrl,
  };
  const config2 = {
    url: `${process.env.REACT_APP_BOT_SERVICE_URL}/skills/retrieveUserSkills?organizationId=${orgId}`,
    method: "get",
    headers: {
      "Content-Type": "application/json",
      // "user_id": user_id,
      Authorization: `Bearer ${token}`,
    },
  };
  const res = await axios(config);
  const response = await axios(config2);
  try {
    var sorted = response.data.data;

    var skillResponse = res.data.data.pageInfo;

    var all_skills = res.data.data.results;
    for (var i = 0; i < all_skills.length; i++) {
      for (var j = 0; j < sorted.length; j++) {
        if (sorted[j].SKILL_NAME === all_skills[i].skill_name) {
          all_skills[i]["isAvailable"] = true;
        }
      }
    }

    return res.data.data;
  } catch (err) {
    dispatch(notify("error", "Failed to retrieve Search : " + err.toString()));
  }
};

export const helperSearch = (data) => async (dispatch) => {
  var newUrl;
  try {
    let token = await getKeycloackToken();

    if (data) {
      newUrl = `${process.env.REACT_APP_BOT_SERVICE_URL}/draftSkills/searchHelper?query=${data.query}&page=${data.page}&pageSize=10`;
    }
    var config = {
      method: "get",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      url: newUrl,
    };

    const result = await axios(config);
    const sendResponse = result.data.data.results;
    return result.data.data;
  } catch (err) {
    dispatch(notify("error", "Failed to retrieve Search : " + err.toString()));
  }
};

export const changeSkillAreaView = (area) => (dispatch, getState) => {
  dispatch({ type: types.UPDATE_SKILL_VIEW, payload: area });
  return area;
};

export const changeActiveCategory = (area) => (dispatch, getState) => {
  dispatch({ type: types.SET_ACTIVE_CATEGORY, payload: area });
  return area;
};

export const changeActiveTab = (tab) => (dispatch) => {
  dispatch({ type: types.GET_ACTIVE_TAB, payload: tab });
  return tab;
};

export const toogleDataMapper = (data) => (dispatch) => {
  dispatch({ type: types.TOOGLE_DATA_MAPPER, payload: data });
};

export const clearDraft = () => (dispatch) => {
  dispatch({ type: types.CLEAR_DRAFTS, payload: [] });
};

export const setDraft = (item) => (dispatch) => {
  dispatch({ type: types.SET_DRAFT, payload: item });
};

export const startTimer = (payload) => (dispatch) => {
  dispatch({ type: types.SET_TIMER, payload: payload });
};

export const setLoading = (payload) => (dispatch) => {
  dispatch({ type: types.LOADING, payload: payload });
};

export const setReadOnly = (item) => (dispatch) => {
  dispatch({ type: types.SET_READ_ONLY, payload: item });
};

export const closeAdvancedConfigPanel = () => async (dispatch) => {
  dispatch({
    type: types.CLOSE_ADVANCED_PANEL,
    payload: {
      record: {},
      mandatory_fields: [],
      optional_fields: [],
      default_values: [],
    },
  });
};

export const setVariablePanel = (flag) => async (dispatch) => {
  dispatch({
    type: types.SET_VARIABLE_PANEL,
    payload: flag,
  });
};

export const setChatPanel = (record) => async (dispatch) => {
  dispatch({
    type: types.SET_CHAT_PANEL,
    payload: {
      record: record?.data,
      panelVisible: record?.panelVisible,
    },
  });
};

export const setRagPanel = (record) => async (dispatch) => {
  dispatch({
    type: types.SET_RAG_PANEL,
    payload: {
      record: record?.data,
      panelVisible: record?.panelVisible,
    },
  });
};

export const setAdvancedConfigPanel = (record) => async (dispatch) => {
  dispatch({
    type: types.SET_ADVANCED_PANEL,
    payload: {
      record: record,
      mandatory_fields: [],
      optional_fields: [],
      default_values: [],
    },
  });
  try {
    let token = await getKeycloackToken();
    var config = {
      method: "get",
      url: `${process.env.REACT_APP_BOT_SERVICE_URL}/skills/getFlowRequirements?type=${record.type}`,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const {
      data: { data },
    } = await axios(config);
    let response;
    if (record.type != "CLICK_EL") {
      response = data[0];
    } else {
      if (record.type === "CLICK_EL" && record.selectorType == "imgSelector") {
        response = data[1];
      } else {
        response = data[0];
      }
    }
    let mandatory_fields =
      response?.MANDATORY_PARAMS !== ""
        ? response.MANDATORY_PARAMS.split(",")
        : [];
    let optional_fields =
      response?.OPTIONAL_PARAMS !== ""
        ? response.OPTIONAL_PARAMS.split(",")
        : [];
    let default_values = _.difference(Object.keys(response.DEFAULT_VALUES), [
      ...mandatory_fields,
      ...optional_fields,
    ]);

    dispatch({
      type: types.SET_ADVANCED_PANEL,
      payload: {
        record: record,
        mandatory_fields,
        optional_fields,
        default_values,
      },
    });
  } catch (e) {
    console.log(e);
  }
};

export const setSelectedFilter = (data) => async (dispatch) => {
  dispatch({
    type: types.SET_SELECTED_FILTER,
    payload: data,
  });
};

export const setSearchQuery = (data) => async (dispatch) => {
  dispatch({
    type: types.SET_SEARCH_QUERY,
    payload: data,
  });
};

export const setUserEmail = (data) => async (dispatch) => {
  dispatch({
    type: types.SET_USER_EMAIL,
    payload: data,
  });
};

export const setSelectedTemplate = (data) => async (dispatch) => {
  dispatch({
    type: types.SET_SELECTED_TEMPLATE,
    payload: data,
  });
};

export const saveFavoriteSkill = (skill) => (dispatch) => {
  let skills = localStorage.getItem("_tf_skill");
  if (skills) {
    skills = JSON.parse(skills);
  } else {
    skills = [];
  }
  skills.push(skill);
  localStorage.setItem("_tf_skill", JSON.stringify(skills));
  dispatch({ type: types.SAVE_FAVOURITE_SKILLS, payload: skill });
};

export const getFavoriteSkills = () => (dispatch) => {
  let skills = localStorage.getItem("_tf_skill");
  if (skills) {
    skills = JSON.parse(skills);
  } else {
    skills = [];
  }
  dispatch({ type: types.GET_FAVOURITE_SKILLS, payload: skills });
};

export const removeFavoriteSkill = (skill) => (dispatch) => {
  let skills = localStorage.getItem("_tf_skill");
  if (skills) {
    skills = JSON.parse(skills);
  } else {
    skills = [];
  }
  skills = skills.filter((item) => item.ID !== skill.ID);
  localStorage.setItem("_tf_skill", JSON.stringify(skills));
  dispatch({ type: types.REMOVE_FAVOURITE_SKILLS, payload: skills });
};

export const updateFormatedData = (data) => async (dispatch) => {
  let token = await getKeycloackToken();

  const config1 = {
    url: `${process.env.REACT_APP_BOT_SERVICE_URL}/skills/updateRpaPayload`,
    method: "put",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    data: data,
  };

  try {
    const res = await axios(config1);
    const formatData = res.data.data;
    dispatch({ type: types.UPDATE_DRAFT, payload: formatData });

    return { success: true, data: formatData };
  } catch (err) {
    if (err.response && err.response.status === 400) {
      const errorMessage = err.response.data.error || "An error occurred";
      return { success: false, error: errorMessage };
    } else {
      console.error(err.toString());
      return { success: false, error: "An error occurred" };
    }
  }
};

export const getSkillsFromStore = (page) => async (dispatch, getState) => {
  let _orgId = getCookie("org_id");
  const orgId = _orgId || null;
  let token = await getKeycloackToken();
  var skillUrl;
  if (page) {
    skillUrl = `${process.env.REACT_APP_BOT_SERVICE_URL}/skills/retrieve?page=${page}`;
  } else {
    skillUrl = `${process.env.REACT_APP_BOT_SERVICE_URL}/skills/retrieve `;
  }
  const config1 = {
    url: skillUrl,
    method: "get",
    headers: {
      "Content-Type": "application/json",
      // "user_id": user_id,
      Authorization: `Bearer ${token}`,
    },
  };
  const config2 = {
    url: `${process.env.REACT_APP_BOT_SERVICE_URL}/skills/retrieveUserSkills?organizationId=${orgId}`,
    method: "get",
    headers: {
      "Content-Type": "application/json",
      // "user_id": user_id,
      Authorization: `Bearer ${token}`,
    },
  };

  const config3 = {
    url: `${process.env.REACT_APP_BOT_SERVICE_URL}/draftSkills/retrieve?TYPE=SkillHub&category=all&page=-1&pageSize=10&_org=${orgId}`,
    method: "get",
    headers: {
      "Content-Type": "application/json",
      // "user_id": user_id,
      Authorization: `Bearer ${token}`,
    },
  };

  try {
    const res = await axios(config1);

    const response = await axios(config2);

    var sorted = response.data.data;
    var skillResponse = res.data.data.pageInfo;
    var all_skills = res.data.data.results;

    for (var i = 0; i < all_skills.length; i++) {
      for (var j = 0; j < sorted.length; j++) {
        if (sorted[j].SKILL_NAME === all_skills[i].skill_name) {
          all_skills[i]["isAvailable"] = true;
        }
      }
    }

    // for (var a = 0; a < all_skills.length; a++) {
    //   for (var b = 0; b < sorted2.length; b++) {
    //     if (sorted2[b].SKILL_NAME === all_skills[a].skill_name) {
    //       all_skills[a]["isAvailable"] = true;
    //     }
    //   }
    // }

    dispatch({ type: types.GET_SKILLS, payload: all_skills });
    dispatch({ type: types.PAGE_INFO_SKILL, payload: skillResponse });

    // dispatch({ type: types.IS_LOADING, payload: { status: false } });

    return res.data.data;
  } catch (err) {
    dispatch({ type: types.GET_SKILLS, payload: [] });
    // dispatch({ type: types.IS_LOADING, payload: { status: false } });
    console.log(err.toString());
  }
};
// get user onboarded skills from skill store
export const getUserSkills = (data) => async (dispatch, getState) => {
  let _orgId = getCookie("org_id");
  const orgId = _orgId || null;
  let token = await getKeycloackToken();

  const config = {
    url: `${
      process.env.REACT_APP_BOT_SERVICE_URL
    }/skills/retrieveUserSkills?page=${
      data ? data.page : 1
    }&pageSize=10&organizationId=${orgId}`,
    method: "get",
    headers: {
      "Content-Type": "application/json",
      // "user_id": user_id,
      Authorization: `Bearer ${token}`,
    },
  };
  try {
    const response = await axios(config);
    var sorted = response.data.data; //Sorts the array based on usage count
    // dispatch({ type: types.IS_LOADING, payload: { status: false } });

    sorted.sort((a, b) => {
      if (a.USAGE_COUNT > b.USAGE_COUNT) return -1;
      if (b.USAGE_COUNT > a.USAGE_COUNT) return 1;
    });

    dispatch({ type: types.GET_MY_SKILLS, payload: sorted });
    return response;
  } catch (err) {
    console.log(err.toString());
  }
};

export const retrieveFilteredMetaSkill = (data) => async (dispatch) => {
  let _orgId = getCookie("org_id");
  const orgId = _orgId.value || null;
  var newUrl = `${process.env.REACT_APP_BOT_SERVICE_URL}/draftSkills/retrieveFilteredMeta?page=${data.page}&filter=${data.filter}&pageSize=9&_org=${orgId}`;
  try {
    let token = await getKeycloackToken();
    var config = {
      method: "get",
      headers: {
        Authorization: `Bearer ${token}`,
      },
      url: newUrl,
    };

    const result = await axios(config);
    const totalCount = result.data.data.total;
    dispatch({
      type: types.GET_FILTERED_METASKILL,
      payload: result.data.data.results,
      filteredMetaCount: totalCount,
    });
    return result.data.data;
  } catch (err) {
    console.log(err, "err");
  }
};

export const retrieveAllMetaTemplates = (data) => async (dispatch) => {
  let _orgId = getCookie("org_id");
  const orgId = _orgId || null;
  var newUrl = `${process.env.REACT_APP_BOT_SERVICE_URL}/draftSkills/retrieveAllMetaTemplates?_org=${orgId}`;
  try {
    let token = await getKeycloackToken();
    var config = {
      method: "get",
      headers: {
        Authorization: `Bearer ${token}`,
      },
      url: newUrl,
    };
    const result = await axios(config);
    dispatch({
      type: types.GET_ALL_TEMPLATES,
      payload: result.data.data.results,
    });
    return result.data.data;
  } catch (err) {
    console.log(err, "err");
    dispatch(notify("error", "Failed to retrieve agent."));
  }
};

export const retrieveMetaByEmail =
  (data, organizationId, email) => async (dispatch) => {
    let _orgId = getCookie("org_id");
    const orgId = _orgId.value || null;
    var newUrl = `${process.env.REACT_APP_BOT_SERVICE_URL}/draftSkills/retrieveMetaByEmail?email=${email}&page=${data.page}&pageSize=9&_org=${organizationId}`;
    try {
      let token = await getKeycloackToken();
      var config = {
        method: "get",
        headers: {
          Authorization: `Bearer ${token}`,
        },
        url: newUrl,
      };
      const result = await axios(config);
      const totalCount = result.data.data.total;
      dispatch({
        type: types.GET_META_BYEMAIL,
        payload: result.data.data,
        metaByEmailCount: totalCount,
      });
      return result.data.data;
    } catch (err) {
      console.log(err, "err");
      dispatch(notify("error", "Failed to retrieve agent."));
    }
  };

export const retrieveMyMetaSkill =
  (email, data, organizationId) => async (dispatch) => {
    let _orgId = getCookie("org_id");
    const orgId = _orgId || null;
    var newUrl = `${process.env.REACT_APP_BOT_SERVICE_URL}/draftSkills/retrieveMyMetaSkill?email=${email}&page=${data.page}&pageSize=9&_org=${organizationId}`;
    try {
      let token = await getKeycloackToken();
      var config = {
        method: "get",
        headers: {
          Authorization: `Bearer ${token}`,
        },
        url: newUrl,
      };
      const result = await axios(config);
      const totalCount = result.data.data.total;
      dispatch({
        type: types.GET_MY_META_SKILL,
        payload: result.data.data,
        myMetaCount: totalCount,
      });
      return result.data.data;
    } catch (err) {
      console.log(err, "err");
      dispatch(notify("error", "Failed to retrieve agent."));
    }
  };

export const searchSKills = (search) => async (dispatch) => {
  try {
    dispatch({
      type: types.SEARCH_SKILLS,
      payload: search,
    });
  } catch (err) {
    console.log(err.toString());
  }
};

export const searchMySKills = (search) => async (dispatch, getState) => {
  const { filterable_myskills } = getState().skills;

  try {
    //this.setState({ skills: sorted, isLoading: false })
    let filtered_skills = [];
    filterable_myskills.map((skill) => {
      if (
        skill.SKILL_NAME.toLowerCase()
          .replace(/\s+/g, "")
          .includes(search.toLowerCase().replace(/\s+/g, ""))
      ) {
        filtered_skills.push(skill);
      }
    });
    dispatch({
      type: types.GET_MY_SKILLS,
      payload: { skills: filtered_skills },
    });
  } catch (err) {
    console.log(err.toString());
  }
};
export const deleteMySkill = (id) => async (dispatch, getState) => {
  let _orgId = getCookie("org_id");
  const orgId = _orgId || null;
  try {
    let token = await getKeycloackToken();
    const config = {
      url: `${process.env.REACT_APP_BOT_SERVICE_URL}/skills/user`,
      method: "delete",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: {
        skill_id: id,
        organisationId: orgId,
      },
    };
    const res = await axios(config);

    dispatch(notify("success", "Agent deleted"));
    // dispatch(getUserSkills(false));
    return res;
  } catch (err) {
    dispatch(notify("error", "Unable to delete agent: " + err.toString()));
  }
};
export const disableUserPopup = () => (dispatch) => {
  dispatch({ type: types.DISABLE_USER_POPUP });
};

export const getPrebuildSkills = () => async (dispatch) => {
  let token = await getKeycloackToken();
  let _orgId = getCookie("org_id");
  const orgId = _orgId || null;
  const config = {
    url: `${process.env.REACT_APP_BOT_SERVICE_URL}/skills/retrieveUserSkills?organizationId=${orgId}`,
    method: "get",
    headers: {
      "Content-Type": "application/json",
      //"user_id": user_id,
      Authorization: `Bearer ${token}`,
    },
  };
  try {
    const response = await axios(config);
    var user_skills = response.data.data; //Sorts the array based on usage count
    var prebuild;
    const response1 = await axios.get(
      `${process.env.REACT_APP_BOT_SERVICE_URL}/skills/retrieve`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );

    prebuild = response1.data.data;

    for (var i = 0; i < user_skills.length; i++) {
      for (var j = 0; j < prebuild.length; j++) {
        if (user_skills[i].SKILL_NAME === prebuild[j].skill_name) {
          prebuild.splice(j, 1);
        }
      }
    }
    // this.setState({ skills: sorted, isLoading: false })
    dispatch({ type: types.GET_PREBUILD_SUCCESS, payload: prebuild });
  } catch (err) {
    console.log(err.toString());
  }
};
export const addSkillToUser = (item) => (dispatch) => {
  dispatch({
    type: types.USER_UPLOAD,
    payload: item.tags[0].skill_fields,
    item: item,
  });
};
export const changeFlowView = (data) => async (dispatch) => {
  dispatch({
    type: types.STAT_CHANGE_FLOW,
    payload: data,
  });
};

export const viewHelperSkill = (item) => (dispatch) => {
  dispatch({
    type: types.VIEW_HELPER_ITEM,
    payload: item,
  });
};

export const publishHelperSkill = (id, payload) => async (dispatch) => {
  try {
    let token = await getKeycloackToken();
    var config = {
      method: "put",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      url: `${process.env.REACT_APP_BOT_SERVICE_URL}/skills/updateRpaPayload`,
      data: payload,
    };
    const result = await axios(config);
    return result;
  } catch (err) {
    dispatch(notify("error", "Failed to delete Agent: " + err.toString()));
  }
};
export const updateDraftSkill = (id, payload) => async (dispatch, getState) => {
  try {
    let token = await getKeycloackToken();
    var config = {
      method: "put",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      url: `${process.env.REACT_APP_BOT_SERVICE_URL}/draftSkills/update/${id}`,
      data: payload,
    };
    const result = await axios(config);
    console.log(result.data.data);
    dispatch({ type: types.GET_DRAFTS_BY_ID, payload: result.data.data });
    return result;
  } catch (err) {
    console.log(err, "e");
    dispatch(notify("error", "Update Failed!"));
  }
};

export const rateSkill = (id, payload) => async (dispatch, getState) => {
  try {
    let token = await getKeycloackToken();
    var config = {
      method: "put",
      headers: {
        Authorization: `Bearer ${token}`,
      },
      url: `${process.env.REACT_APP_BOT_SERVICE_URL}/draftSkills/rateSkill/${id}`,
      data: payload,
    };
    const result = await axios(config);
    dispatch({ type: types.GET_DRAFTS_BY_ID, payload: result.data.data });
    return result;
  } catch (err) {
    console.log(err, "e");
    dispatch(notify("error", "Update Failed!"));
  }
};
export const deleteDraftSkill =
  (id, template) => async (dispatch, getState) => {
    try {
      let token = await getKeycloackToken();
      var config = {
        method: "delete",
        headers: {
          Authorization: `Bearer ${token}`,
        },
        url: `${process.env.REACT_APP_BOT_SERVICE_URL}/draftSkills/delete?id=${id}&template=${template}`,
      };
      const result = await axios(config);
      dispatch(notify("success", "Agent deleted successfully!"));
      return result;
    } catch (err) {
      dispatch(notify("error", "Failed to delete agent: " + err.toString()));
    }
  };

export const getSession = (data) => async (dispatch) => {
  let token = await getKeycloackToken();

  var conf = {
    method: "get",
    url: `${process.env.REACT_APP_BOT_SERVICE_URL}/user/retrieveSession`,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  const sessionRes = await axios(conf);
  const sessionData = sessionRes.data.data.results;
  let getCurrentSession = (sessionData[0] && sessionData[0].id) || null;
  dispatch({
    type: types.DEVICES,
    payload: getCurrentSession,
    devices: sessionData,
  });
  return sessionData[0];
};

export const deleteSessionById = (id) => async (dispatch) => {
  let token = await getKeycloackToken();
  try {
    const conf = {
      method: "delete",
      url: `${process.env.REACT_APP_BOT_SERVICE_URL}/user/session/${id}`,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };

    const res = await axios(conf);
    dispatch(notify("success", "Session deleted"));
    return res;
  } catch (err) {
    dispatch(notify("error", "Unable to delete session: " + err.toString()));
  }
};

const checkBrowser = async () => {
  const userAgent = navigator.userAgent.toLowerCase();
  let browser;
  if (userAgent.indexOf("chrome") > -1 && userAgent.indexOf("edg") === -1) {
    browser = "chrome";
  }
  if (userAgent.indexOf("edg") > -1) {
    browser = "edge";
  }

  return browser;
};
export const startRecord = (data) => async (dispatch, getState) => {
  try {
    dispatch({
      type: types.IS_RECORDING,
      payload: { status: true, nodeId: data.nodeId },
    });
    let browserType = await checkBrowser();
    await sendMessageToExtension({
      browser: browserType,
      type: "startRecording",
      skillId: data.skillId,
      markerIndex: data.markerIndex,
      nodeId: data.nodeId,
      variantId: data?.variantId ?? null,
    });
    dispatch(notify("success", "Training started."));
  } catch (e) {
    console.log(e, "e");
    dispatch(notify("error", "Failed to start training."));
    dispatch({
      type: types.IS_RECORDING,
      payload: { status: false, nodeId: data.nodeId },
    });
    dispatch({
      type: types.SET_TIMER,
      payload: false,
    });
  }
};

export const stopRecord = (data) => async (dispatch, getState) => {
  try {
    let browserType = await checkBrowser();

    await sendMessageToExtension({
      browser: browserType,
      type: "stopRecording",
      deviceId: data.deviceId,
      skillId: data.skillId,
      markerIndex: data.markerIndex,
      nodeId: data.nodeId,
      variantId: data?.variantId ?? null,
    });
    dispatch({
      type: types.IS_RECORDING,
      payload: { status: false, nodeId: data.nodeId },
    });

    dispatch(
      notify(
        "success",
        "Show process stopped. Please wait while we process the data."
      )
    );
    return {
      status: true,
    };
  } catch (e) {
    dispatch(notify("error", "Unable to stop recording..."));
    return {
      status: false,
    };
  }
};

export const triggerPannel = (record) => async (dispatch) => {
  dispatch({
    type: types.OPEN_PANEL,
    payload: {
      record: record,
      mandatory_fields: [],
      optional_fields: [],
      default_values: [],
    },
  });
  try {
    let token = await getKeycloackToken();
    var config = {
      method: "get",
      url: `${process.env.REACT_APP_BOT_SERVICE_URL}/skills/getFlowRequirements?type=${record.type}`,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios(config);
    let default_values = [];
    for (const [key, value] of Object.entries(
      response.data.data[0].DEFAULT_VALUES
    )) {
      default_values.push(key);
    }
    dispatch({
      type: types.OPEN_PANEL,
      payload: {
        record: record,
        mandatory_fields:
          response.data.data[0].MANDATORY_PARAMS != ""
            ? response.data.data[0].MANDATORY_PARAMS.split(",")
            : [],
        optional_fields:
          response.data.data[0].OPTIONAL_PARAMS != ""
            ? response.data.data[0].OPTIONAL_PARAMS.split(",")
            : [],
        default_values: default_values,
      },
    });
  } catch (e) {
    console.log(e);
  }
};

export const createDraftSkill =
  (skill, callback) => async (dispatch, getState) => {
    try {
      const organisationId =
        getState().organizationReducer.currentOrganization.id;
      skill["organizationId"] = organisationId;
      let token = await getKeycloackToken();
      var config = {
        method: "post",
        url: `${process.env.REACT_APP_BOT_SERVICE_URL}/draftSkills/create`,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        data: skill,
      };
      const result = await axios(config);
      if (result?.data?.status) {
        callback();
        skill["id"] = result.data.data.id;
        dispatch({ type: types.CREATE_DRAFT, payload: skill });
        return result;
      } else {
        return result;
      }
    } catch (err) {
      if (err.toString().includes(403)) {
        return {
          msg: "Agent creation limit exceeded. Please renew/upgrade your plan.",
        };
      }
      dispatch(notify("error", "Failed to Create Agent: " + err.toString()));
    }
  };

export const cloneDraftSkill = (skill) => async (dispatch, getState) => {
  try {
    const organisationId =
      getState().organizationReducer.currentOrganization.id;
    skill["organizationId"] = organisationId;
    let token = await getKeycloackToken();
    var config = {
      method: "post",
      url: `${process.env.REACT_APP_BOT_SERVICE_URL}/draftSkills/clone`,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: skill,
    };
    const result = await axios(config);
    if (result?.data?.status) {
      dispatch({ type: types.CREATE_DRAFT, payload: skill });
      return result;
    } else {
      return result;
    }
  } catch (err) {
    dispatch(notify("error", "Failed to clone agent: " + err.toString()));
  }
};

export const getDraftSkills = (data) => async (dispatch, getState) => {
  var newUrl;
  let _orgId = getCookie("org_id");
  const orgId = _orgId || null;
  // const orgId = getState().organizationReducer.currentOrganization.id;
  try {
    if (data === "SkillHub") {
      newUrl = `${process.env.REACT_APP_BOT_SERVICE_URL}/draftSkills/retrieveAllHelperSkill&_org=${orgId}`;
    } else if (data?.type === "SkillHub" && data?.category && data?.page) {
      newUrl = `${process.env.REACT_APP_BOT_SERVICE_URL}/draftSkills/retrieve?TYPE=SkillHub&category=${data.category}&page=${data.page}&pageSize=10&_org=${orgId}`;
    } else if (data === "getCount") {
      newUrl = `${process.env.REACT_APP_BOT_SERVICE_URL}/draftSkills/retrieve?TYPE=SkillHub&getCount&_org=${orgId}`;
    } else if (data?.applyFilter === "all") {
      newUrl = `${
        process.env.REACT_APP_BOT_SERVICE_URL
      }/draftSkills/retrieveRegularSkill?filterSkills=all&page=${
        data ? data.page : 1
      }&pageSize=10&_org=${orgId}`;
    } else {
      newUrl = `${
        process.env.REACT_APP_BOT_SERVICE_URL
      }/draftSkills/retrieveRegularSkill?page=${
        data ? data.page : 1
      }&pageSize=10&_org=${orgId}`;
    }
    let token = await getKeycloackToken();
    var config = {
      method: "get",
      headers: {
        Authorization: `Bearer ${token}`,
      },
      url: newUrl,
    };
    const result = await axios(config);
    const totalCount = result.data.data.total;
    dispatch({
      type: types.GET_DRAFTS,
      payload: result.data.data.results,
      totalCount: totalCount,
    });
    dispatch({ type: types.PAGE_INFO_DRAFT, payload: result.data.data });
    return result.data.data;
  } catch (err) {
    console.log(err, "err");
    dispatch(notify("error", "Failed to retrieve agent: " + err.toString()));
  }
};

export const getAllSkillSets = (data) => async (dispatch, getState) => {
  var newUrl;
  let _orgId = getCookie("org_id");
  const orgId = _orgId || null;
  try {
    newUrl = `${
      process.env.REACT_APP_BOT_SERVICE_URL
    }/draftSkills/retrieveAllSkillSets?filterSkills=all&page=${
      data ? data.page : 1
    }&pageSize=10&_org=${orgId}`;

    let token = await getKeycloackToken();
    var config = {
      method: "get",
      headers: {
        Authorization: `Bearer ${token}`,
      },
      url: newUrl,
    };
    const result = await axios(config);
    const totalCount = result.data.data.total;
    dispatch({
      type: types.GET_DRAFTS,
      payload: result.data.data.results,
      totalCount: totalCount,
    });
    dispatch({ type: types.PAGE_INFO_DRAFT, payload: result.data.data });
    return result.data.data;
  } catch (err) {
    console.log(err, "err");
    dispatch(
      notify("error", "Failed to retrieve skill set: " + err.toString())
    );
  }
};

export const getMetaDataSkills = (data) => async (dispatch) => {
  let _orgId = getCookie("org_id");
  const orgId = _orgId || null;
  var newUrl = `${
    process.env.REACT_APP_BOT_SERVICE_URL
  }/draftSkills/retrieveMetaDataSkill?page=${
    data ? data.page : 1
  }&pageSize=10&_org=${orgId}`;
  try {
    let token = await getKeycloackToken();
    var config = {
      method: "get",
      headers: {
        Authorization: `Bearer ${token}`,
      },
      url: newUrl,
    };
    const result = await axios(config);
    return result;
  } catch (err) {
    console.log(err, "err");
  }
};

export const retrieveFilteredSkillSets = (data) => async (dispatch) => {
  let _orgId = getCookie("org_id");
  const orgId = _orgId.value || null;
  var newUrl = `${process.env.REACT_APP_BOT_SERVICE_URL}/draftSkills/retrieveFilteredSkillSets?page=${data.page}&filter=${data.filter}&pageSize=9&_org=${orgId}`;
  try {
    let token = await getKeycloackToken();
    var config = {
      method: "get",
      headers: {
        Authorization: `Bearer ${token}`,
      },
      url: newUrl,
    };

    const result = await axios(config);
    const filteredSkillSetCount = result.data.data.filtered_total;
    dispatch({
      type: types.GET_FILTERED_SKILLSET,
      payload: result.data.data.results,
      filteredSkillSetCount: filteredSkillSetCount,
    });
    return result.data.data;
  } catch (err) {
    console.log(err, "err");
  }
};

export const searchMetaDataSkills = (query) => async (dispatch) => {
  let _orgId = getCookie("org_id");
  const orgId = _orgId || null;
  const { page = 1, limit = 9, query: searchQuery } = query;
  var newUrl = `${process.env.REACT_APP_BOT_SERVICE_URL}/draftSkills/searchSkill?page=${page}&query=${searchQuery}&limit=${limit}&_org=${orgId}`;
  try {
    let token = await getKeycloackToken();
    var config = {
      method: "get",
      headers: {
        Authorization: `Bearer ${token}`,
      },
      url: newUrl,
    };
    const response = await axios(config);
    const metaSearchCount = response.data.data.total_count;
    dispatch({
      type: types.SEARCH_METADATA_SKILL,
      payload: response.data.data.results,
      metaSearchCount: metaSearchCount,
    });
    return response.data.data.results;
  } catch (err) {
    console.error(err);
    throw new Error("Failed to retrieve agent.");
  }
};

export const searchMetaDataSkillsByTemplate = (data) => async (dispatch) => {
  let _orgId = getCookie("org_id");
  const orgId = _orgId.value || null;
  var newUrl = `${process.env.REACT_APP_BOT_SERVICE_URL}/draftSkills/searchSkillByTemplate?page=${data.page}&query=${data.query}&template=${data.template}&_org=${orgId}`;
  try {
    let token = await getKeycloackToken();
    var config = {
      method: "get",
      headers: {
        Authorization: `Bearer ${token}`,
      },
      url: newUrl,
    };
    const response = await axios(config);
    const metaSearchCountByTemp = response.data.data.total_count;
    dispatch({
      type: types.SEARCH_METASKILL_BYTEMPLATE,
      payload: response.data.data.results,
      metaSearchCountByTemp: metaSearchCountByTemp,
    });
    return response.data.data.results;
  } catch (err) {
    console.error(err);
    throw new Error("Failed to retrieve agent.");
  }
};

export const getDraftSkillCount = () => async (dispatch) => {
  var newUrl = `${process.env.REACT_APP_BOT_SERVICE_URL}/draftSkills/retrieveHelperCount`;
  try {
    let token = await getKeycloackToken();
    var config = {
      method: "get",
      headers: {
        Authorization: `Bearer ${token}`,
      },
      url: newUrl,
    };
    const result = await axios(config);
    return result.data.data;
  } catch (err) {
    console.log(err, "err");
    dispatch(notify("error", "Failed to retrieve agent."));
  }
};
export const retrieveFilteredSkill = (data) => async (dispatch) => {
  let _orgId = getCookie("org_id");
  const orgId = _orgId || null;
  var newUrl = `${process.env.REACT_APP_BOT_SERVICE_URL}/draftSkills/retrieveFilteredSkill?page=${data.page}&filter=${data.filter}&pageSize=9&_org=${orgId}`;
  try {
    let token = await getKeycloackToken();
    var config = {
      method: "get",
      headers: {
        Authorization: `Bearer ${token}`,
      },
      url: newUrl,
    };
    const result = await axios(config);
    const filteredCount = result.data.data.filtered_total;
    dispatch({
      type: types.GET_FILTERED_SKILL,
      payload: result.data.data,
      filteredCount: filteredCount,
    });
    return result.data.data;
  } catch (err) {
    console.log(err, "err");
    dispatch(notify("error", "Failed to retrieve agent."));
  }
};

export const getProcessDiscoverySkills = (data) => async (dispatch) => {
  let _orgId = getCookie("org_id");
  const orgId = _orgId.value || null;
  var newUrl = `${
    process.env.REACT_APP_BOT_SERVICE_URL
  }/draftSkills/retrieveFilteredSkill?page=${data.page || 1}&filter=${
    data.filter
  }&pageSize=9&_org=${orgId}`;
  try {
    let token = await getKeycloackToken();
    var config = {
      method: "get",
      headers: {
        Authorization: `Bearer ${token}`,
      },
      url: newUrl,
    };
    const result = await axios(config);
    const _count = result.data.data.filtered_total;
    dispatch({
      type: types.PROCESS_SKILL,
      payload: result.data.data,
      count: _count,
    });
    return result.data.data;
  } catch (err) {
    dispatch(
      notify(
        `error", "Failed to retrieve process discovery agent.${err.toString()}`
      )
    );
  }
};

export const retrieveAllTemplates = (data) => async (dispatch) => {
  let _orgId = getCookie("org_id");
  const orgId = _orgId.value || null;
  var newUrl = `${process.env.REACT_APP_BOT_SERVICE_URL}/draftSkills/retrieveAllTemplates?_org=${orgId}`;
  try {
    let token = await getKeycloackToken();
    var config = {
      method: "get",
      headers: {
        Authorization: `Bearer ${token}`,
      },
      url: newUrl,
    };
    const result = await axios(config);
    const totalCount = result.data.data.total;
    dispatch({
      type: types.GET_ALL_TEMPLATES,
      payload: result.data.data.results,
      totalCount: totalCount,
    });
    return result.data.data;
  } catch (err) {
    console.log(err, "err");
    dispatch(notify("error", "Failed to retrieve agent."));
  }
};

export const retrieveDraftByEmail =
  (data, organizationId, email) => async (dispatch) => {
    let _orgId = getCookie("org_id");
    const orgId = _orgId.value || null;
    var newUrl = `${process.env.REACT_APP_BOT_SERVICE_URL}/draftSkills/retrieveDraftByEmail?email=${email}&page=${data.page}&pageSize=9&_org=${organizationId}`;
    try {
      let token = await getKeycloackToken();
      var config = {
        method: "get",
        headers: {
          Authorization: `Bearer ${token}`,
        },
        url: newUrl,
      };
      const result = await axios(config);
      const totalCount = result.data.data.total;
      dispatch({
        type: types.GET_DRAFT_BYEMAIL,
        payload: result.data.data,
        skillByEmailCount: totalCount,
      });
      return result.data.data;
    } catch (err) {
      console.log(err, "err");
      dispatch(notify("error", "Failed to retrieve agent."));
    }
  };

export const retrieveMySkills =
  (email, data, organizationId) => async (dispatch) => {
    let _orgId = getCookie("org_id");
    const orgId = _orgId.value || null;
    var newUrl = `${process.env.REACT_APP_BOT_SERVICE_URL}/draftSkills/retrieveMySkills?email=${email}&page=${data.page}&pageSize=9&_org=${organizationId}`;
    try {
      let token = await getKeycloackToken();
      var config = {
        method: "get",
        headers: {
          Authorization: `Bearer ${token}`,
        },
        url: newUrl,
      };
      const result = await axios(config);
      const allCount = result.data.data.total;
      dispatch({
        type: types.GET_ALL_SKILLS,
        payload: result.data.data,
        allCount: allCount,
      });
      return result.data.data;
    } catch (err) {
      console.log(err, "err");
      dispatch(notify("error", "Failed to retrieve agent."));
    }
  };

export const retrieveMySkillSets =
  (email, data, organizationId) => async (dispatch) => {
    let _orgId = getCookie("org_id");
    const orgId = _orgId.value || null;
    var newUrl = `${process.env.REACT_APP_BOT_SERVICE_URL}/draftSkills/retrieveMySkillSets?email=${email}&page=${data.page}&pageSize=9&_org=${organizationId}`;
    try {
      let token = await getKeycloackToken();
      var config = {
        method: "get",
        headers: {
          Authorization: `Bearer ${token}`,
        },
        url: newUrl,
      };
      const result = await axios(config);
      const totalSkillSetCount = result.data.data.total;
      dispatch({
        type: types.GET_MY_SKILLSET,
        payload: result.data.data,
        totalSkillSetCount: totalSkillSetCount,
      });
      return result.data.data;
    } catch (err) {
      console.log(err, "err");
      dispatch(notify("error", "Failed to retrieve agent."));
    }
  };

export const retrieveSkillSetByEmail =
  (data, organizationId, email) => async (dispatch) => {
    let _orgId = getCookie("org_id");
    const orgId = _orgId.value || null;
    var newUrl = `${process.env.REACT_APP_BOT_SERVICE_URL}/draftSkills/retrieveSkillSetByEmail?email=${email}&page=${data.page}&pageSize=9&_org=${organizationId}`;
    try {
      let token = await getKeycloackToken();
      var config = {
        method: "get",
        headers: {
          Authorization: `Bearer ${token}`,
        },
        url: newUrl,
      };
      const result = await axios(config);
      const countByEmail = result.data.data.total;
      dispatch({
        type: types.GET_SKILLSET_BY_EMAIL,
        payload: result.data.data,
        countByEmail: countByEmail,
      });
      return result.data.data;
    } catch (err) {
      console.log(err, "err");
      dispatch(notify("error", "Failed to retrieve agent."));
    }
  };

export const getUserHelperSkills = (data) => async (dispatch, getState) => {
  let _orgId = getCookie("org_id");
  const orgId = _orgId || null;
  var newUrl;
  if (data && data.page) {
    newUrl = `${process.env.REACT_APP_BOT_SERVICE_URL}/draftSkills/retrieveUserHelper?page=${data.page}&pageSize=10&_org=${orgId}`;
  } else {
    newUrl = `${process.env.REACT_APP_BOT_SERVICE_URL}/draftSkills/retrieveUserHelper&_org=${orgId}`;
  }
  try {
    let token = await getKeycloackToken();
    var config = {
      method: "get",
      headers: {
        Authorization: `Bearer ${token}`,
      },
      url: newUrl,
    };
    const result = await axios(config);
    // console.log("result", result);
    dispatch({
      type: types.GET_USER_HELPER,
      payload: result.data.data,
    });
    // dispatch({ type: types.PAGE_INFO_DRAFT, payload: result.data.data });
    return result.data.data;
  } catch (err) {
    console.log(err, "err");
    dispatch(notify("error", "Failed to retrieve agent."));
  }
};

export const getHelperTask = (data) => async (dispatch) => {
  var newUrl;
  if (data) {
    newUrl = `${process.env.REACT_APP_BOT_SERVICE_URL}/draftSkills/retrieveHelperTask?page=${data}&pageSize=15`;
  } else {
    newUrl = `${process.env.REACT_APP_BOT_SERVICE_URL}/draftSkills/retrieveHelperTask`;
  }

  try {
    let token = await getKeycloackToken();
    var config = {
      method: "get",
      headers: {
        Authorization: `Bearer ${token}`,
      },
      url: newUrl,
    };
    const result = await axios(config);
    dispatch({ type: types.GET_HELPER_TASK, payload: result.data.data });
    return result.data.data;
  } catch (err) {
    dispatch(notify("error", "Failed to retrieve agent: " + err.toString()));
  }
};

export const getDraftSkillsById = (id) => async (dispatch, getState) => {
  let _orgId = getCookie("org_id");
  const orgId = _orgId || null;

  try {
    dispatch({ type: types.LOADING, payload: true });
    let token = await getKeycloackToken();
    var config = {
      method: "post",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      url: `${process.env.REACT_APP_BOT_SERVICE_URL}/draftSkills/retrieveDraft`,
      data: { id, orgId },
    };
    const result = await axios(config);
    dispatch({
      type: types.GET_DRAFTS_BY_ID,
      payload: result.data.data,
      skillMeta: result.data.skillMeta,
    });
    dispatch({ type: types.LOADING, payload: false });
    return result;
  } catch (err) {
    dispatch({ type: types.LOADING, payload: false });
    // dispatch(
    //   notify("error", "Failed to retrieve Draft Skill: " + err.toString())
    // );
    window.location.href = "/dashboard/skills/unauthorised";
  }
};

export const approveDraftSkill = (payload, status) => async (dispatch) => {
  try {
    let token = await getKeycloackToken();
    var config = {
      method: "put",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      url: `${process.env.REACT_APP_BOT_SERVICE_URL}/draftSkills/updateTaskStatus?status=${status}`,
      data: payload,
    };
    const result = await axios(config);
    if (result) {
      return result;
    }
  } catch (err) {
    dispatch(notify("error", "Failed to approve agent: " + err.toString()));
  }
};

export const executeFlow = (data) => async (dispatch) => {
  try {
    let _data;
    let restoreChrome = data?.restoreChrome ? data.restoreChrome : false;
    let _checkAgent = await desktopAgentExists();

    if (_checkAgent.desktopAgentExists) {
      restoreChrome = data?.restoreChrome;
    } else {
      restoreChrome = false;
    }

    let _orgId = getCookie("org_id");
    const orgId = _orgId || null;
    if (data.variables) {
      _data = {
        deviceId: data.deviceId,
        skillId: data.skillId,
        variables: data.variables,
        orgId: orgId,
        ...data,
      };
    } else {
      _data = {
        deviceId: data.deviceId,
        skillId: data.skillId,
        orgId: orgId,
        ...data,
      };
    }
    await sendMessageToExtension({
      type: "executeSkill",
      skillId: data.skillId,
      source: "superWebApp",
      restoreChrome,
      ..._data,
    });

    dispatch(
      notify("success", "Please wait while we trigger the automation agent")
    );
  } catch (e) {
    dispatch(notify("error", "Failed to execute the automation agent"));
  }
};

export const setSelectedItem = (item) => (dispatch) => {
  dispatch({ type: types.SET_SELECTED_ITEM, payload: item });
};

export const searchDraft = (data) => async (dispatch) => {
  let _orgId = getCookie("org_id");
  const orgId = parseInt(_orgId) || null;
  let token = await getKeycloackToken();
  console.log(data, "data");
  var config = {
    method: "get",
    url: `${process.env.REACT_APP_BOT_SERVICE_URL}/draftSkills/search?query=${data.query}&filter=${data.filter}&page=${data.page}&email=${data.email}&orgId=${orgId}`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  const response = await axios(config);
  const searchCount = response.data.data.search_count;
  dispatch({
    type: types.SET_SEARCH_SKILL,
    payload: response.data.data,
    searchCount: searchCount,
  });
  return response.data.data;
};

export const searchSkillsByTemplate = (data) => async (dispatch) => {
  let _orgId = getCookie("org_id");
  const orgId = _orgId || null;
  let token = await getKeycloackToken();
  console.log(data, "data");
  var config = {
    method: "get",
    url: `${process.env.REACT_APP_BOT_SERVICE_URL}/draftSkills/searchFiltered?query=${data.query}&page=${data.page}&template=${data.template}&orgId=${orgId}`,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };

  const response = await axios(config);
  const searchFilteredCount = response.data.data.filteredSearch_count;
  dispatch({
    type: types.SET_FILTERED_SKILL,
    payload: response.data.data,
    searchFilteredCount: searchFilteredCount,
  });
  return response.data.data;
};

export const sendRequestAccess = (data) => async (dispatch, getState) => {
  let token = await getKeycloackToken();
  var config = {
    method: "post",
    url: `${process.env.REACT_APP_BOT_SERVICE_URL}/inviteEmail`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
    data: { ...data },
  };
  try {
    const { data } = await axios(config);
    return true;
  } catch (err) {
    return false;
  }
};

export const addBranchNode = (data) => async (dispatch, getState) => {
  let token = await getKeycloackToken();
  var config = {
    method: "put",
    url: `${process.env.REACT_APP_BOT_SERVICE_URL}/draftSkills/branch`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
    data: data,
  };
  try {
    const response = await axios(config);
    return true;
  } catch (err) {
    return false;
  }
};

// Get Sheet Headers

export const getSheetHeaders = (sheetUrl, sheetName) => async (dispatch) => {
  try {
    let url;
    let _urlObj = new URL(sheetUrl);
    if (_urlObj.hostname.match("google.com")) {
      url = _urlObj.href.replace("/edit", "/export?format=csv");
    } else {
      url = sheetUrl;
    }
    let { data } = await axios.get(url, {
      responseType: "arraybuffer",
      withCredentials: false,
    });
    var file = new Blob([data], { type: "application/vnd.ms-excel" });
    let workBook = await read(await file.arrayBuffer(), { type: "array" });
    sheetName = sheetName || "Sheets1";
    var sheetData = utils.sheet_to_json(workBook.Sheets[sheetName], {
      header: 1,
    });
    dispatch({ type: types.GET_SHEET_HEADERS, payload: sheetData[0] });
    return sheetData[0];
  } catch (e) {
    console.log(e);
  }
};

export const addSkillSetFromStore = (data) => async (dispatch) => {
  try {
    let _orgId = getCookie("org_id");
    const orgId = _orgId || null;
    let token = await getKeycloackToken();
    var config = {
      method: "post",
      url: `${process.env.REACT_APP_BOT_SERVICE_URL}/skills/user/uploadSkillSet`,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: data,
    };
    const response = await axios(config);
    return response;
  } catch (err) {
    dispatch(notify("error", "Failed to add skill: " + err.toString()));
  }
};

export const addSkillFromStore = (data) => async (dispatch) => {
  try {
    let _orgId = getCookie("org_id");
    const orgId = _orgId || null;
    let token = await getKeycloackToken();
    var config = {
      method: "post",
      url: `${process.env.REACT_APP_BOT_SERVICE_URL}/skills/user/uploadSkill`,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: {
        skill_meta: data.skillMeta,
        skill_name: data.skillName,
        skill_id: data.skillId,
        organization_id: orgId,
      },
    };
    const response = await axios(config);
  } catch (err) {
    dispatch(notify("error", "Failed to add agent: " + err.toString()));
  }
};

export const getAllSkillSet = (data) => async (dispatch, getState) => {
  let _orgId = getCookie("org_id");
  const orgId = _orgId || null;
  try {
    let newUrl = `${process.env.REACT_APP_BOT_SERVICE_URL}/draftSkills/retrieveSkillSet?category=${data.category}&page=${data.page}&pageSize=9&_org=${orgId}`;

    let token = await getKeycloackToken();
    var config = {
      method: "get",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      url: newUrl,
    };
    const result = await axios(config);
    dispatch({
      type: types.GET_ALL_SKILLSET,
      payload: result?.data?.data,
    });

    return result?.data?.data;
  } catch (err) {
    console.log(err, "err");
    dispatch(
      notify("error", "Failed to retrieve draft agent: " + err.toString())
    );
  }
};

export const getSkillSet = (id) => async (dispatch, getState) => {
  let _orgId = getCookie("org_id");
  const orgId = _orgId || null;
  try {
    let newUrl = `${process.env.REACT_APP_BOT_SERVICE_URL}/draftSkills/getSkillSet?skillId=${id}`;

    let token = await getKeycloackToken();
    var config = {
      method: "get",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      url: newUrl,
    };
    const result = await axios(config);
    return result?.data?.data?.results;
  } catch (err) {
    console.log(err, "err");
    dispatch(
      notify("error", "Failed to retrieve draft agent: " + err.toString())
    );
  }
};

export const getAllSkillSetSkills = (data) => async (dispatch, getState) => {
  let _orgId = getCookie("org_id");
  const orgId = _orgId || null;
  try {
    let newUrl = `${process.env.REACT_APP_BOT_SERVICE_URL}/draftSkills/getAllSkillSetSkills?skillId=${data}&_org=${orgId}`;

    let token = await getKeycloackToken();
    var config = {
      method: "get",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      url: newUrl,
    };
    const result = await axios(config);
    return result?.data?.data?.results;
  } catch (err) {
    console.log(err, "err");
    dispatch(
      notify("error", "Failed to retrieve draft agent: " + err.toString())
    );
  }
};

export const getPopularSkills = (data) => async (dispatch, getState) => {
  let _orgId = getCookie("org_id");
  const orgId = _orgId || null;
  try {
    let newUrl = `${process.env.REACT_APP_BOT_SERVICE_URL}/draftSkills/retrieveMostPopularSkill?category=${data.category}&page=${data.page}&pageSize=9&_org=${orgId}`;

    let token = await getKeycloackToken();
    var config = {
      method: "get",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      url: newUrl,
    };
    const result = await axios(config);
    dispatch({
      type: types.GET_MOST_POPULAR_SKILL,
      payload: result?.data?.data,
    });
    return result?.data?.data;
  } catch (err) {
    console.log(err, "err");
    dispatch(
      notify("error", "Failed to retrieve draft agent: " + err.toString())
    );
  }
};

export const getTrendingSkills = (data) => async (dispatch, getState) => {
  let _orgId = getCookie("org_id");
  const orgId = _orgId || null;
  try {
    let newUrl = `${process.env.REACT_APP_BOT_SERVICE_URL}/draftSkills/retrieveTrendingSkill?category=${data.category}&page=${data.page}&pageSize=9&_org=${orgId}`;

    let token = await getKeycloackToken();
    var config = {
      method: "get",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      url: newUrl,
    };
    const result = await axios(config);
    dispatch({
      type: types.GET_TRENDING_SKILL,
      payload: result?.data?.data,
    });
    return result?.data?.data;
  } catch (err) {
    console.log(err, "err");
    dispatch(notify("error", "Failed to retrieve agent: " + err.toString()));
  }
};

export const searchSkillStore = (data) => async (dispatch) => {
  let _orgId = getCookie("org_id");
  const orgId = _orgId || null;
  let token = await getKeycloackToken();
  var newUrl;
  if (data) {
    newUrl = `${process.env.REACT_APP_BOT_SERVICE_URL}/draftSkills/searchStoreSkill?search=${data.query}&page=${data.page}&pageSize=10`;
  }
  const config = {
    method: "get",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    url: newUrl,
  };

  try {
    const res = await axios(config);
    var all_skills = res.data.data;

    return res.data.data;
  } catch (err) {
    dispatch(notify("error", "Failed to retrieve Search : " + err.toString()));
  }
};

export const getAuthorDetail = (data) => async (dispatch) => {
  try {
    let token = await getKeycloackToken();
    var config = {
      method: "get",
      url: `${process.env.REACT_APP_BOT_SERVICE_URL}/userDetails/getUserDetails?email=${data}`,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const result = await axios(config);
    return result;
  } catch (err) {
    dispatch(
      notify("error", "Failed to fetch author details: " + err.toString())
    );
  }
};

export const createAuthorDetail = (user) => async (dispatch) => {
  try {
    let token = await getKeycloackToken();
    var config = {
      method: "post",
      url: `${process.env.REACT_APP_BOT_SERVICE_URL}/userDetails/createUserDetails`,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: user,
    };
    const result = await axios(config);
    console.log(result, "userRes");
    return result;
  } catch (err) {
    dispatch(
      notify("error", "Failed to create author details: " + err.toString())
    );
  }
};
export const updateAuthorDetail = (user) => async (dispatch) => {
  try {
    let token = await getKeycloackToken();
    var config = {
      method: "put",
      url: `${process.env.REACT_APP_BOT_SERVICE_URL}/userDetails/updateUserDetails`,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: user,
    };
    const result = await axios(config);
    console.log(result, "userRes");
    return result;
  } catch (err) {
    dispatch(
      notify("error", "Failed to create author details: " + err.toString())
    );
  }
};

export const getDocument = (query) => async (dispatch) => {
  try {
    let token = await getKeycloackToken();
    var config = {
      method: "get",
      responseType: "blob",
      url: `${process.env.REACT_APP_BOT_SERVICE_URL}/document/download?id=${query.id}`,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const result = await axios(config);
    if (result?.data) {
      dispatch(notify("success", "Please wait file is being downloaded"));
      const url = window.URL.createObjectURL(new Blob([result.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `${query.skillName}.pdf`);
      document.body.appendChild(link);
      link.click();
      window.URL.revokeObjectURL(url);
    }
  } catch (err) {
    dispatch(notify("error", "Failed to download document " + err.toString()));
  }
};

export const createRevision = (data) => async (dispatch) => {
  try {
    let token = await getKeycloackToken();
    var config = {
      method: "post",
      url: `${process.env.REACT_APP_BOT_SERVICE_URL}/draftSkills/createRevision`,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: data,
    };
    const result = await axios(config);
    return result;
  } catch (err) {
    dispatch(notify("error", "Failed to create revision: " + err.toString()));
  }
};
export const updateRevision = (data) => async (dispatch) => {
  try {
    let token = await getKeycloackToken();
    var config = {
      method: "put",
      url: `${process.env.REACT_APP_BOT_SERVICE_URL}/draftSkills/updateRevision`,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: data,
    };
    const result = await axios(config);
    return result;
  } catch (err) {
    dispatch(notify("error", "Failed to update revision: " + err.toString()));
  }
};

export const updateRevisionLabel = (id, label) => async (dispatch) => {
  try {
    let token = await getKeycloackToken();
    var config = {
      method: "put",
      url: `${process.env.REACT_APP_BOT_SERVICE_URL}/draftSkills/updateRevisionLabel`,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: { id: id, label: label },
    };
    const result = await axios(config);
    return result;
  } catch (err) {
    dispatch(notify("error", "Failed to update revision: " + err.toString()));
  }
};

export const listAllRevisions =
  (skillId, pageInfo, filter, filterLabel, start = null, end = null) =>
  async (dispatch) => {
    try {
      let token = await getKeycloackToken();
      var config = {
        method: "get",
        url: `${
          process.env.REACT_APP_BOT_SERVICE_URL
        }/draftSkills/retrieveDraft/${skillId}/revisions?page=${
          pageInfo.current
        }&pageSize=${pageInfo.pageSize}&filter=${filter ?? ""}&filterLabel=${
          filterLabel ?? ""
        }&startDate=${start}&endDate=${end}`,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      };
      const result = await axios(config);
      dispatch({
        type: types.LIST_VARIANTS_DATA,
        payload: result.data,
      });

      return result;
    } catch (err) {
      dispatch(
        notify("error", "Failed to fetch all revision: " + err.toString())
      );
    }
  };
export const listUserRevisions =
  (skillId, pageInfo, filter, filterLabel, start = null, end = null) =>
  async (dispatch) => {
    try {
      let token = await getKeycloackToken();
      var config = {
        method: "get",
        url: `${
          process.env.REACT_APP_BOT_SERVICE_URL
        }/draftSkills/getUserVariants/${skillId}?page=${
          pageInfo.current
        }&pageSize=${pageInfo.pageSize}&filter=${
          filter ? filter : ""
        }&filterLabel=${filterLabel ?? ""}&startDate=${start}&endDate=${end}`,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      };
      const result = await axios(config);
      dispatch({
        type: types.LIST_VARIANTS_DATA,
        payload: result.data,
      });

      return result;
    } catch (err) {
      dispatch(
        notify("error", "Failed to fetch all variants: " + err.toString())
      );
    }
  };

export const getSelectedRevision = (skillId, id) => async (dispatch) => {
  try {
    dispatch({ type: types.LOADING, payload: true });

    let token = await getKeycloackToken();
    var config = {
      method: "get",
      url: `${process.env.REACT_APP_BOT_SERVICE_URL}/draftSkills/getRevision/${skillId}/revision/${id}`,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const result = await axios(config);
    dispatch({ type: types.GET_DRAFTS_BY_ID, payload: result.data.data });
    dispatch({ type: types.LOADING, payload: false });

    return result;
  } catch (err) {
    dispatch({ type: types.LOADING, payload: false });

    dispatch(
      notify("error", "Failed to fetch all revision: " + err.toString())
    );
  }
};

export const addToCompare = (flowAction) => (dispatch) => {
  dispatch({ type: types.ADD_TO_COMPARE, payload: flowAction });
};

export const getAggregatedFlow = (data) => async (dispatch) => {
  try {
    let token = await getKeycloackToken();
    var config = {
      method: "post",
      url: `${process.env.REACT_APP_BOT_SERVICE_URL}/draftSkills/aggregate`,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: data,
    };
    const result = await axios(config);
    dispatch({ type: types.AGGREGATED_RESULT, payload: result?.data?.data });

    return result;
  } catch (err) {
    dispatch(notify("error", "Failed to aggregate: " + err.toString()));
  }
};

export const convertToAutomation = (skill) => async (dispatch, getState) => {
  try {
    const organisationId =
      getState().organizationReducer.currentOrganization.id;
    skill["organizationId"] = organisationId;
    let token = await getKeycloackToken();
    var config = {
      method: "post",
      url: `${process.env.REACT_APP_BOT_SERVICE_URL}/draftSkills/convert-automation`,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: skill,
    };
    const result = await axios(config);
    if (result?.data?.status) {
      return result;
    } else {
      return result;
    }
  } catch (err) {
    if (err.toString().includes(403)) {
      return {
        msg: "Skill creation limit exceeded. Please renew/upgrade your plan.",
      };
    }
    if (err.toString().includes(400)) {
      return {
        msg: "Agent name is already taken. Please choose another name",
      };
    }
    dispatch(
      notify("error", "Failed to Convert to automation: " + err.toString())
    );
  }
};

export const setAggregateData = (flow) => (dispatch) => {
  dispatch({ type: types.AGGREGATED_RESULT, payload: flow });
};

export const deleteVariant = (ids) => async (dispatch) => {
  try {
    let token = await getKeycloackToken();
    var config = {
      method: "delete",
      url: `${process.env.REACT_APP_BOT_SERVICE_URL}/draftSkills/deleteRevisionById`,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: { id: ids },
    };
    const result = await axios(config);
    return result;
  } catch (err) {
    dispatch(notify("error", "Failed to delete: " + err.toString()));
  }
};

export const setVariantsData = (data) => async (dispatch) => {
  try {
    dispatch({
      type: types.LIST_VARIANTS_DATA,
      payload: data,
    });
  } catch (err) {
    dispatch(notify("error", "Failed to set variants: " + err.toString()));
  }
};

export const getMetrics =
  (skillId, startDate = null, endDate = null) =>
  async (dispatch) => {
    try {
      dispatch({ type: types.LOADING_METRICS, payload: true });

      let token = await getKeycloackToken();
      var config = {
        method: "get",
        url: `${process.env.REACT_APP_BOT_SERVICE_URL}/draftSkills/getRpdMetrics/${skillId}?startDate=${startDate}&endDate=${endDate}`,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      };
      const result = await axios(config);
      dispatch({
        type: types.SET_RPD_METRICS,
        payload: result?.data?.data,
      });
      dispatch({ type: types.LOADING_METRICS, payload: false });
    } catch (err) {
      dispatch({ type: types.LOADING_METRICS, payload: false });

      dispatch(notify("error", "Failed to get metrics: " + err.toString()));
    }
  };
export const setSkillId = (id) => async (dispatch) => {
  try {
    dispatch({
      type: types.SET_SKILL_ID,
      payload: id,
    });
  } catch (err) {
    dispatch(notify("error", "Failed to set agent id: " + err.toString()));
  }
};

export const setDateFilter = (dates) => async (dispatch) => {
  try {
    dispatch({
      type: types.SET_DATE_FILTER,
      payload: dates,
    });
  } catch (err) {
    dispatch(notify("error", "Failed to set dates: " + err.toString()));
  }
};

// Create GenAi Skill

export const createGenAiSkill = (skill) => async (dispatch, getState) => {
  try {
    const organisationId =
      getState().organizationReducer.currentOrganization.id;
    skill["orgId"] = organisationId;
    let token = await getKeycloackToken();
    var config = {
      method: "post",
      url: `${process.env.REACT_APP_BOT_SERVICE_URL}/genAi/createAutomation`,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: skill,
    };
    const result = await axios(config);
    return result;
  } catch (err) {
    if (err.toString().includes(403)) {
      return {
        msg: "Agent creation limit exceeded. Please renew/upgrade your plan.",
      };
    }
    dispatch(notify("error", "Failed to Create Agent: " + err.toString()));
  }
};

export const getGenAiSkills = (data) => async (dispatch, getState) => {
  try {
    let token = await getKeycloackToken();
    var config = {
      method: "get",
      url: `${process.env.REACT_APP_BOT_SERVICE_URL}/genAi/getAllAutomation?page=${data.page}`,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const result = await axios(config);
    return result;
  } catch (err) {
    console.log(err, "eeeee");
    dispatch(notify("error", "Failed to fetch Agent: " + err.toString()));
  }
};

export const deleteGenAiSkills = (id) => async (dispatch, getState) => {
  try {
    let token = await getKeycloackToken();
    var config = {
      method: "delete",
      url: `${process.env.REACT_APP_BOT_SERVICE_URL}/genAi/deleteAutomation/${id}`,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const result = await axios(config);
    return result;
  } catch (err) {
    dispatch(notify("error", "Failed to delete Agent: " + err.toString()));
  }
};

export const getGenAiSkillById = (id) => async (dispatch, getState) => {
  try {
    let token = await getKeycloackToken();
    var config = {
      method: "get",
      url: `${process.env.REACT_APP_BOT_SERVICE_URL}/genAi/getAutomationById/${id}`,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const result = await axios(config);
    return result;
  } catch (err) {
    console.log(err, "eeeee");
    dispatch(notify("error", "Failed to fetch Agent: " + err.toString()));
  }
};

export const createAgentV2 =
  (skill, callback) => async (dispatch, getState) => {
    try {
      const organisationId =
        getState().organizationReducer.currentOrganization.id;
      skill["organizationId"] = organisationId;
      let token = await getKeycloackToken();

      const requestOptions = {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "x-source": "v1",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(skill),
      };
      const response = await fetch(
        `${process.env.REACT_APP_V2_URL}/api/v1/agent/new`,
        requestOptions
      );

      const result = await response.json();
     

      if (result?.status) {
        callback();
        skill["id"] = result.data;
        return result;
      } else {
        return result;
      }
    } catch (err) {
      if (err.message.includes("403")) {
        return {
          msg: "Agent creation limit exceeded. Please renew/upgrade your plan.",
        };
      }
      dispatch(notify("error", "Failed to Create Agent: " + err.toString()));
    }
  };

export const getSessionV2 = () => async (dispatch) => {
  try {
    let token = await getKeycloackToken();

    const requestOptions = {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
        "x-source": "v1",
        "Content-Type": "application/json",
      },
      // url: `${process.env.REACT_APP_V2_URL}/api/v1/onboard/verifySession`,
      credentials: "include",
    };
    const response = await fetch(
      `${process.env.REACT_APP_V2_URL}/api/v1/onboard/verifySession`,
      requestOptions
    );

    const result = await response.json();

    return result;
  } catch (err) {
    console.log(err, "Error");
    // dispatch(notify("error", "Failed to verify session: " + err.toString()));
  }
};

export const deleteV2Agent = (id) => async (dispatch) => {
  try {
    const agent = {
      agentId: id,
    };
    let token = await getKeycloackToken();

    const requestOptions = {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "x-source": "v1",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(agent),
      credentials: "include",
    };
    const response = await fetch(
      `${process.env.REACT_APP_V2_URL}/api/v1/agent/deleteAgent`,

      requestOptions
    );

    const result = await response.json();
    return result;
  } catch (err) {
    console.log(err, "Error");
    // dispatch(notify("error", "Failed to verify session: " + err.toString()));
  }
};

export const checkAndOnboardAgent =
  (skill, callback) => async (dispatch, getState) => {
    try {
      const organisationId =
        getState().organizationReducer.currentOrganization.id;
      skill["organizationId"] = organisationId;
      let token = await getKeycloackToken();
      const requestOptions = {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "x-source": "v1",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(skill),
      };
      const response = await fetch(
        `${process.env.REACT_APP_V2_URL}/api/v1/agent/newAutomationSkill`,
        requestOptions
      );

      const result = await response.json();

      if (!response.ok) {
        throw new Error(result?.message || "Failed to create agent");
      }

      if (result?.status) {
        callback();
        skill["id"] = result.data;
        return result;
      } else {
        return result;
      }
    } catch (err) {
      if (err.message.includes("403")) {
        return {
          msg: "Agent creation limit exceeded. Please renew/upgrade your plan.",
        };
      }
      dispatch(notify("error", "Failed to Create Agent: " + err.toString()));
    }
  };

export const getSkillStoreData = () => async (dispatch) => {
    let _orgId = getCookie("org_id");
    const orgId = _orgId || null;
    var newUrl=`${process.env.REACT_APP_BOT_SERVICE_URL}/draftSkills/aiAgentHub`;
    try {
      let token = await getKeycloackToken();
      var config = {
        method: "get",
        headers: {
          Authorization: `Bearer ${token}`,
        },
        url: newUrl,
      };
      const result = await axios(config);
      dispatch({
        type: types.AI_AGENT_HUB_DATA,
        payload: result.data.data,
      });
      return result.data.data;
      
      
    } catch (err) {
      console.log(err, "err");
      dispatch(notify("error", "Failed to retrieve agent: " + err.toString()));
    }

   
}
export const updateStoreView = (data) => async (dispatch) => {
  dispatch({
    type: types.AI_AGENT_HUB_DATA,
    payload: data,
  });
}